<div class="main-block-content mt-2 mb-2" style="height: 350px; overflow-x: hidden; overflow-y: auto;">
  <app-common-table-dark [columnDefs]="columnDefs" [data]="gridData"
    (selectedRowsChange)="onRowChange($event)"></app-common-table-dark>
</div>

<div class="actionbtnDiv pb-2">
  <button type="submit" class="btn btn-primary mr-1" [disabled]="!hasSelection" (click)="onSubmit($event)">{{okButton}}</button>
  <button type="button" class="btn btn-secondary mr-2" (click)="Close()">{{cancelButton}}</button>
</div>